import http from '../utils/http';

const baseUrl = '/py';

export default {
    findAllPYClient() {
        return http.get({
            url: baseUrl + `/client/v1`
        });
    },

    findContractsByFilter(receivingDistrictId, receivingLocationId, client) {
        var params = '?';
        if (receivingLocationId) {
            let prefix = params.length > 1 ? '&' : '';
            params = params + prefix + 'receivingLocationId=' + receivingLocationId;
        }
        if (receivingDistrictId) {
            let prefix = params.length > 1 ? '&' : '';
            params = params + prefix + 'receivingDistrictId=' + receivingDistrictId;
        }
        if (client) {
            let prefix = params.length > 1 ? '&' : '';
            params = params + prefix + 'client=' + client;
        }
        if (params.length === 1) {
            params = '';
        }
        return http.get({
            url: `/contrato-rastreabilidade/v1/avaliable-volume${params}`
        });
    },

    findVolumeTotalizer() {
        return http.get({
            url: '/relatorio-rastreabilidade/v1/volume-totalizers'
        });
    },

    sendSaveFinish(params) {
        return http.post({
            url: '/relatorio-rastreabilidade/v1/',
            data: params
        });
    },

    cancelReport(id, justification) {
        return http.post({
            url: `/relatorio-rastreabilidade/v1/cancel?id=${id}&justification=${justification}`
        });
    },

    findById(id) {
        return http.get({
            url: `/relatorio-rastreabilidade/v1/${id}`
        });
    },

    findReportContractsById(id) {
        return http.get({
            url: `/relatorio-rastreabilidade/v1/${id}/contracts`
        });
    },

    filterTraceabilityReport(filter) {
        let url = `/relatorio-rastreabilidade/v1?page=${filter.page}&size=${filter.size}`;
        if (filter.initialreportDate) {
            url += `&initialReportDate=${filter.initialreportDate}&finalReportDate=${filter.finalReportDate}`;
        }
        if (filter.minReportVolume) {
            url += `&minReportVolume=${filter.minReportVolume}&maxReportVolume=${filter.maxReportVolume}`;
        }
        if (filter.status) {
            url += `&status=${filter.status}`;
        }
        if (filter.reportNumber) {
            url += `&reportNumber=${filter.reportNumber}`;
        }
        return http.get({ url });
    },

    downloadDocument(id) {
        return http.get({
            url: `/relatorio-rastreabilidade/v1/pdf/${id}`,
            responseType: 'blob',
            lockScreen: true
        });
    }
};
